import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import HideAppBar from "../../../widgets/header/HideAppBar";
import {useForm, FormProvider} from "react-hook-form";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Container, Fab,
	Grid,
	Tooltip,
	Typography
} from "@mui/material";
import {useHistory, useParams} from "react-router-dom";
import {AnagraficaContext, AppContext} from "../../../../App";
import {getAnagraficaById, updateAnagrafica} from "../../../../services/AnagraficaServices";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import {resetAnagrafica} from "./utils/ResetUtils";
import clsx from "clsx";
import {getAnaGraficaApi} from "../../../../services/utils/TicketApiData";
import {setOpenSnackbar} from "../../../../services/AppServices";
import DiarioPaziente from "../../../widgets/diary/DiarioPaziente";
import {InfoLavorativeGrid} from "./content/InfoLavorativeGrid";
import {SintomiGrid} from "./content/SintomiGrid";
import {RischioGrid} from "./content/RischioGrid";
import {amber, green} from "@mui/material/colors";
import DoneOutlineTwoToneIcon from "@mui/icons-material/DoneOutlineTwoTone";
import {initIntervistaState, INTERVISTA_INITIAL_STATE, IntervistaReducer} from "../../../../reducers/IntervistaReducer";
import {generateIntervista, segnaGestitiTamponiSoggetto, setIntervista} from "../../../../services/IntervistaServices";
import {getIntervistaApiData} from "../../../../services/utils/IntervistaApiData";
import {QuarantenaGrid} from "./content/QuarantenaGrid";
import {generateQuarantenaV4} from "../../../../services/QuaranteneServices";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";

const IntervistaOperatore = () => {
	const classes = BaseStyle();
	const methods = useForm({mode: "onChange"})
	const {idSoggetto} = useParams();
	let history = useHistory();
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const [isResetAnagrafica, setResetAnagrafica] = useState(false);
	const [submitUpdate, setSubmitUpdate] = useState(false);
	const [submitQuarantena, setSubmitQuarantena] = useState(false);
	const [submit, setSubmit] = useState(false);
	const [all, setAll] = useState(false);
	const [intervistaState, intervistaDispatch] = useReducer(IntervistaReducer, INTERVISTA_INITIAL_STATE, initIntervistaState);
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	
	const onSubmit = useCallback((data, all) => {
		console.log(all)
		if (all && all === "all") {
			setAll(true);
		}
		console.log(data);
		setSubmit(true);
		setIntervista(getIntervistaApiData(data), intervistaDispatch);
		segnaGestitiTamponiSoggetto(idSoggetto);
		generateIntervista({
			...data,
			type: "OPR",
			...getIntervistaApiData(data),
			soggetto: {
				...getAnaGraficaApi({
					...anagraficaContext.state.anagrafica, ...data?.soggetto,
				}),
				idSoggetto: idSoggetto,
			}
		}, intervistaDispatch)
	}, [intervistaDispatch, idSoggetto, anagraficaContext.state.anagrafica])
	
	const handleUpdateAnagrafica = useCallback(() => {
		setSubmitUpdate(true);
		updateAnagrafica(getAnaGraficaApi({
			...anagraficaContext.state.anagrafica, ...methods.getValues()?.soggetto,
		}), idSoggetto, anagraficaContext.dispatch);
	}, [idSoggetto, anagraficaContext.state.anagrafica, anagraficaContext.dispatch, methods])
	
	useEffect(() => {
		getAnagraficaById(idSoggetto, anagraficaContext.dispatch);
	}, [idSoggetto, anagraficaContext.dispatch])
	
	useEffect(() => {
		if (submit && !intervistaState.loadingAddIntervista && intervistaState.errorAddIntervista === "") {
			setSubmit(false);
			console.log("Ok, intervista creata correttamente!")
			if (all) {
				setSubmitQuarantena(true);
				let data = methods.getValues();
				generateQuarantenaV4({
						...data["soggetto"],
						groupId: data.tipoContatto,
						tipoPaziente: data.tipoContatto === "Caso indice" ? "PAZ_ZERO" : "CON_COV",
						idSoggetto: idSoggetto
					},
					{
						...data,
						tipoPaziente: data.tipoContatto === "Caso indice" ? "PAZ_ZERO" : "CON_COV",
						indirizzo: data?.soggetto?.indirizzoDomicilio
					}, intervistaState.intervista.id, null, quarantenaDispatch);
			} else {
				setOpenSnackbar("success", "Intervista creata correttamente! Verrai rimandato indietro tra 2 secondi", appContext.dispatch);
				setTimeout(() => {
					history.goBack();
				}, 2000)
			}
		} else if (submit && !intervistaState.loadingAddIntervista && intervistaState.errorAddIntervista !== "") {
			setSubmit(false);
			console.log("Oooops, si è rotto qualcosa :(")
		}
	}, [intervistaState.loadingAddIntervista, intervistaState.errorAddIntervista, submit, intervistaState.intervista.id, methods, idSoggetto, all, history, appContext.dispatch])
	
	useEffect(() => {
		if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena === "") {
			setOpenSnackbar("success", "Ordinanza creata correttamente! Verrai rimandato indietro tra 2 secondi", appContext.dispatch);
			setTimeout(() => {
				history.goBack();
			}, 2000)
		} else if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena !== "") {
			setSubmitQuarantena(false);
			setOpenSnackbar("error", quarantenaState.errorGenerateQuarantena, appContext.dispatch);
		}
	}, [submitQuarantena, quarantenaState.loadingGenerateQuarantena, quarantenaState.errorGenerateQuarantena, appContext.dispatch, history])
	
	useEffect(() => {
		if (!isResetAnagrafica && !anagraficaContext.state.loadingGetAnagrafica && anagraficaContext.state.errorGetAnagrafica === "") {
			methods.reset({
				soggetto: resetAnagrafica(anagraficaContext.state.anagrafica)
			});
			setResetAnagrafica(true)
		}
	}, [anagraficaContext.state.anagrafica, anagraficaContext.state.loadingGetAnagrafica, anagraficaContext.state.errorGetAnagrafica,
		methods, isResetAnagrafica])
	
	useEffect(() => {
		if (submitUpdate && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica === "") {
			setSubmitUpdate(false);
			setOpenSnackbar("success", "Anagrafica aggiornata correttamente", appContext.dispatch);
		} else if (submitUpdate && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica !== "") {
			setSubmitUpdate(false);
			setOpenSnackbar("error", anagraficaContext.state.errorUpdateAnagrafica, appContext.dispatch);
		}
	}, [submitUpdate, anagraficaContext.state.loadingUpdateAnagrafica, anagraficaContext.state.errorUpdateAnagrafica, appContext.dispatch])
	
	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Crea intervista"}/>
				<Container component={"section"} maxWidth={"xl"} style={{paddingTop: 12}}>
					<form onSubmit={methods.handleSubmit(onSubmit)}>
						<FormProvider {...methods}>
							
							<Grid container spacing={3}>
								
								<Grid item xs={12} md={7}>
									
									<Grid container spacing={3} style={{maxHeight: "92vh", overflowY: "auto", overflowX: "hidden"}}>
										<Grid item xs={12}>
											
											<Card className={clsx(classes.roundBorder)}
											      style={{height: "100%", display: "flex", flexDirection: "column"}}>
												<CardHeader
													title={<Typography variant={"h6"}><b>Soggetto da intervistare</b></Typography>}
													subheader={"Verifica con il paziente la correttezza dei campi anagrafici e dove possibile aggiungi\n" +
														"informazioni. Più ne aggiungi ora e più faciliti il lavoro del paziente per i futuri\n" +
														"operatori."}
												/>
												<CardContent style={{flexGrow: 1}}>
													
													<Grid container spacing={3}>
														<AnagraficaCompleta moreInfo={true} intro={"false"} classes={classes} name={"soggetto."}/>
													</Grid>
												
												</CardContent>
												<CardActions className={classes.flexRight}>
													<Tooltip title={"Aggiorna le informazioni anagrafiche del paziente"}>
														<Button size={"small"} className={classes.roundButton} style={{borderRadius: 24}}
														        variant={"contained"} color={"primary"} disableElevation disabled={submitUpdate}
														        onClick={handleUpdateAnagrafica}>
															<b>Aggiorna</b>
														</Button>
													</Tooltip>
												</CardActions>
											</Card>
										
										</Grid>
										
										<Grid item xs={12}>
											
											<Card className={clsx(classes.roundBorder)}
											      style={{height: "100%", display: "flex", flexDirection: "column"}}>
												<CardHeader
													title={<Typography variant={"h6"}><b>Intervista base</b></Typography>}
													subheader={"Compila l'intervista per il paziente"}
												/>
												<CardContent style={{flexGrow: 1}}>
													
													<Grid container spacing={3}>
														<InfoLavorativeGrid isCit={false}/>
														{
															methods.watch("appartieneComunita") !== "true" &&
															<React.Fragment>
																<SintomiGrid isCit={false} dataSintomiReq={true}/>
																<RischioGrid isCit={false}/>
															</React.Fragment>
														}
													</Grid>
												
												</CardContent>
											</Card>
										
										</Grid>
										
										<Grid item xs={12}>
											
											<Card className={clsx(classes.roundBorder)}
											      style={{height: "100%", display: "flex", flexDirection: "column"}}>
												<CardHeader
													title={<Typography variant={"h6"}><b>Ordinanza</b></Typography>}
													subheader={"Compila i dati per creare l'ordinanza al paziente."}
												/>
												<CardContent style={{flexGrow: 1}}>
													
													<Grid container spacing={3}>
														<QuarantenaGrid/>
													</Grid>
												
												</CardContent>
											</Card>
										
										</Grid>
									
									</Grid>
								</Grid>
								
								<Grid item xs={5} style={{maxHeight: "92vh", overflowY: "auto", overflowX: "hidden"}}>
									<DiarioPaziente idSoggetto={idSoggetto}/>
								</Grid>
							
							
							</Grid>
						
						</FormProvider>
					</form>
				</Container>
				<div className={classes.fabContainer}>
					<Fab
						variant={"extended"}
						type={"submit"}
						style={{
							backgroundColor: amber[500],
							color: "#000"
						}}
						className={clsx(classes.fab, classes.greenFab)}
						onClick={methods.handleSubmit(onSubmit)} disabled={submit}
					>
						<DoneOutlineTwoToneIcon className={classes.extendedIconFab}/>
						Compila solo intervista
					</Fab>
					
					<Fab
						variant={"extended"}
						type={"submit"}
						style={{
							backgroundColor: green[500],
							color: "#fff"
						}}
						className={clsx(classes.fab, classes.greenFab)}
						onClick={methods.handleSubmit((data) => onSubmit(data, "all"))} disabled={submit}
					>
						<DoneOutlineTwoToneIcon className={classes.extendedIconFab}/>
						Compila intervista + ordinanza
					</Fab>
				</div>
			</main>
		</React.Fragment>
	);
};

export default React.memo(IntervistaOperatore);
